import { SURVEY_CHART_SUCCESS, SURVEY_CHART_FAIL } from "../actionTypes";

const initialState = {
  chartData: [],
};

const cultureFitGraphReducer = (state = initialState, action) => {
  switch (action.type) {
    case SURVEY_CHART_SUCCESS:
      return {
        ...state,
        chartData: action?.payload?.body,
      };
    case SURVEY_CHART_FAIL:
      return {
        ...state,
        chartData: [],
      };
    default:
      break;
  }
  return state;
};

export default cultureFitGraphReducer;
